// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-theme="green"] {
    --primary: #5BB040;
    &[data-mode="dark"] {
        --background: #121C11;
        --color: #a2afbd;
        --bar-background: #1D2B1A;
        --bar-color: #6C6E74;
        --border-color: #23341F; 
        --active-border-color: #5BB040;
        --hover-background: #334030;
        --selected-background: #314c2e;
        --selected-color: #d7dae0;
        --drop-background: #142E48;
    }
    &[data-mode="light"] {
        --background: #ebeeeb;
        --color: #121C11; 
        --bar-background: #5BB040;
        --bar-color: #596058;
        --border-color: #D2D7DE;
        --active-border-color: #373A40;
        --hover-background: #b8c3b7;
        --selected-background: #8a9c87;
        --selected-color: #15181c;
        --drop-background: #b8c0c8;
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
